const SECONDS_PER_HOUR = 3600;

const pad = (value: number): string => String(value).padStart(2, '0');

/** Renders whole seconds as HH:MM:SS, growing past 99 hours rather than wrapping. */
export function formatSessionTime(totalSeconds: number): string {
    const safe = Math.max(0, Math.floor(totalSeconds));
    const hours = Math.floor(safe / SECONDS_PER_HOUR);
    const minutes = Math.floor((safe % SECONDS_PER_HOUR) / 60);
    return `${pad(hours)}:${pad(minutes)}:${pad(safe % 60)}`;
}

/** Shown while the remaining time is still unknown. */
export const EMPTY_SESSION_TIME = '--:--:--';
